export const gridPresets = {
  fiveRows: {
    offsetCol: { uneven: 0, even: 0 },
    hole: [],
    columns: 5,
  },
  fiveRowsOffset: {
    offsetCol: {
      uneven: 0.25,
      even: -0.25,
    },
    hole: [],
    columns: 5,
  },
  fiveRowsHole: {
    offsetCol: { uneven: 0, even: 0 },
    hole: [1.2, 1.5, 1.2], //1.5 = 1.5card height, working from the center out
    columns: 5,
  },
	fourRowsHoleMobile: {
    offsetCol: { uneven: 0, even: 0 },
    hole: [2.7, 2.7], //1.5 = 1.5card height, working from the center out
    columns: 4,
  },
	fourRowsHole: {
    offsetCol: { uneven: 0, even: 0 },
    hole: [1.5, 1.5], //1.5 = 1.5card height, working from the center out
    columns: 4,
  },
	fourRows: {
    offsetCol: { uneven: 0, even: 0 },
    hole: [],
    columns: 4,
  },
  fourRowsOffset: {
    offsetCol: { uneven: 0.25, even: -0.25 },
    hole: [],
    columns: 4,
  },
	threeRows: {
    offsetCol: { uneven: 0, even: 0 },
    hole: [],
    columns: 3,
  },
	twoRows: {
    offsetCol: { uneven: 0, even: 0 },
    hole: [],
    columns: 2,
  },
  twoRowsOffset: {
    offsetCol: { uneven: 0.5, even: 0 },
    hole: [],
    columns: 2,
  },
};